export default "__VITE_ASSET__2a80ec89__"